import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const AttributeResetNsk = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
    >
      <path
        d="M19.2 12L21.3005 15.1507C21.443 15.3644 21.7571 15.3644 21.8996 15.1507L24.0001 12H19.2Z"
        fill={color}
      />
      <path
        d="M12 1.20001C9.11602 1.20001 6.40312 2.32261 4.36292 4.36291L6.05972 6.05971C9.23322 2.88391 14.7656 2.88631 17.939 6.05971L19.6358 4.36291C17.5967 2.32261 14.8851 1.20001 12 1.20001Z"
        fill={color}
      />
      <path
        d="M19.6359 4.36292L17.9391 6.05972C19.8258 7.94532 20.6906 10.5433 20.3156 13.1882L22.6922 13.5257C23.175 10.1261 22.0617 6.78631 19.6359 4.36292Z"
        fill={color}
      />
      <path
        d="M4.79998 12L2.69948 8.8493C2.55698 8.6356 2.24288 8.6356 2.10038 8.8493L-0.00012207 12H4.79998Z"
        fill={color}
      />
      <path
        d="M3.6844 10.8117L1.3078 10.4742C0.825002 13.8738 1.9383 17.2124 4.3629 19.6359L6.0597 17.939C4.1742 16.0547 3.3083 13.4566 3.6844 10.8117Z"
        fill={color}
      />
      <path
        d="M17.9391 17.939C14.768 21.1125 9.23438 21.1148 6.05978 17.939L4.36298 19.6359C6.40318 21.6773 9.11608 22.8 12.0001 22.8C14.8841 22.8 17.597 21.6773 19.636 19.6359L17.9391 17.939Z"
        fill={color}
      />
      <path
        d="M9.67262 7.12731L7.12732 9.67261L14.3273 16.8726L16.8726 14.3273L9.67262 7.12731Z"
        fill={color}
      />
      <path
        d="M14.3273 7.12742L7.12732 14.3274L9.67262 16.8727L16.8726 9.67272L14.3273 7.12742Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

AttributeResetNsk.displayName = 'AttributeResetNsk';
